import { PropsWithChildren } from 'react';

const SectionCard = ({ children, className }: { className?: string } & PropsWithChildren) => (
  <div className={`flex flex-1 flex-col gap-5 p-6 bg-base-80 rounded-xl shadow-s ${className || ''}`}>{children}</div>
);

export default SectionCard;
